import estampa1 from "./COPA-DO-MUNDO-2026-COPO-300ml-2.jpg"
import estampa2 from "./COPA-DO-MUNDO-2026-COPO-300ml-2.5.jpg"
import estampa3 from "./COPA-DO-MUNDO-2026-COPO-300ml-4.jpg"
import estampa4 from "./COPA-DO-MUNDO-2026-COPO-300ml-8.jpg"
import estampa5 from "./COPA-DO-MUNDO-2026-COPO-300ml-9.jpg"
import estampa6 from "./COPA-DO-MUNDO-2026-COPO-300ml10.jpg"
import estampa7 from "./COPA-DO-MUNDO-2026-COPO-300ml11.jpg"

export const imagensCopa = [
  {
    "nome": "Copa 01",
    "tipo": "jpg",
    "caminho": estampa1
  },
  {
    "nome": "Copa 02",
    "tipo": "jpg",
    "caminho": estampa2
  },
  {
    "nome": "Copa 03",
    "tipo": "jpg",
    "caminho": estampa3
  },
  {
    "nome": "Copa 04",
    "tipo": "jpg",
    "caminho": estampa4
  },
  {
    "nome": "Copa 05",
    "tipo": "jpg",
    "caminho": estampa5
  },
  {
    "nome": "Copa 06",
    "tipo": "jpg",
    "caminho": estampa6
  },
  {
    "nome": "Copa 07",
    "tipo": "jpg",
    "caminho": estampa7
  }
];